exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs-container {\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  position: relative; }\n  .tabs-container .tabs {\n    top: 0;\n    height: 42px;\n    position: absolute;\n    width: 100%;\n    margin-bottom: 0px !important;\n    justify-content: flex-start; }\n  .tabs-container .panes {\n    position: absolute;\n    top: 42px;\n    height: calc(100% - 42px);\n    max-height: calc(100% - 42px);\n    width: 100%;\n    max-width: 100%;\n    overflow: hidden; }\n    .tabs-container .panes .pane {\n      width: 100%;\n      max-width: 100%;\n      overflow: auto;\n      height: 100%;\n      max-height: 100%;\n      display: none; }\n    .tabs-container .panes .pane.active {\n      display: block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/tabs/style.scss
// module id = 1244
// module chunks = 0